import React, { Children } from 'react';
import { ArrowDown } from 'lucide-react';
import { motion } from 'framer-motion';
const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 40
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-12 px-4 overflow-hidden" data-id="element-70">
      <div className="absolute inset-0 bg-background z-0" data-id="element-71"></div>
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-accent-yellow/5 rounded-full blur-[120px] pointer-events-none" data-id="element-72"></div>

      <motion.div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center" variants={container} initial="hidden" animate="show" data-id="element-73">
        <motion.div variants={item} className="mb-6 inline-block" data-id="element-74">
          <span className="py-1 px-3 border border-accent-yellow/30 rounded-full text-accent-yellow text-xs md:text-sm font-bold tracking-widest uppercase bg-accent-yellow/5" data-id="element-75">
            For ESL Professionals & Expats
          </span>
        </motion.div>

        <motion.h1 variants={item} className="font-heading text-6xl md:text-8xl lg:text-9xl leading-[0.9] text-primary mb-8 text-balance" data-id="element-76">
          Stop Feeling Like a{' '}
          <span className="text-accent-yellow relative inline-block" data-id="element-77">
            "Child"
            <svg className="absolute w-full h-3 -bottom-1 left-0 text-accent-yellow" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-78">
              <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="3" fill="none" data-id="element-79" />
            </svg>
          </span>{' '}
          in English
        </motion.h1>

        <motion.p variants={item} className="text-lg md:text-2xl text-muted max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-80">
          The 5-Minute Script to Reclaim Your{' '}
          <span className="text-primary font-semibold" data-id="element-81">Adult Personality</span>.
          Stop being the "quiet one" and start owning the room.
        </motion.p>

        <motion.div variants={item} className="flex flex-col sm:flex-row gap-4 items-center mb-6" data-id="element-82">
          <motion.button whileHover={{
          scale: 1.04
        }} whileTap={{
          scale: 0.97
        }} onClick={() => document.getElementById('final-cta')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-accent-orange text-white font-bold py-4 px-8 rounded-full text-lg transition-colors duration-200 shadow-[0_0_30px_-5px_rgba(0,168,107,0.4)] hover:shadow-[0_0_40px_-5px_rgba(0,168,107,0.6)]" data-id="element-83">
            GET THE SURVIVAL SCRIPT →
          </motion.button>
          <span className="text-muted text-sm" data-id="element-84">
            30-Day Money Back Guarantee
          </span>
        </motion.div>

        <motion.p variants={item} className="text-muted text-sm mb-12" data-id="element-85">
          🔥 Trusted by{' '}
          <span className="text-primary font-semibold" data-id="element-86">
            2,400+ ESL professionals
          </span>{' '}
          in 40+ countries
        </motion.p>

        <motion.div variants={item} className="animate-bounce text-muted opacity-40" data-id="element-87">
          <ArrowDown size={32} data-id="element-88" />
        </motion.div>
      </motion.div>
    </section>;
}